import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const sources = [{
  name: 'Método Silva',
  application: 'Técnicas Alpha — Tomo 1'
}, {
  name: 'Neville Goddard',
  application: 'Scripting y Teatro Mental — Tomos 2 y 5'
}, {
  name: 'Joseph Murphy',
  application: 'Programación nocturna — Tomo 5'
}, {
  name: 'HeartMath Institute',
  application: 'Coherencia cardíaca — Tomo 4'
}, {
  name: 'Abraham Hicks',
  application: 'Técnica de 17 segundos — Tomo 3'
}, {
  name: 'Dr. Joe Dispenza',
  application: 'Cuerpo y manifestación — Tomo 4'
}, {
  name: 'Carl Jung',
  application: 'Sincronías y sueños — Bono 1'
}];
export function AuthoritySection() {
  return <SectionWrapper bgColor="bg-brand-black" data-id="element-24">
      <h2 className="font-heading text-2xl md:text-3xl text-brand-ivory text-center font-semibold" data-id="element-25">
        El Protocolo 24H integra lo mejor de:
      </h2>

      <div className="mt-10 max-w-2xl mx-auto space-y-3" data-id="element-26">
        {sources.map((s, i) => <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between gap-1 sm:gap-4 px-5 py-3.5 rounded-lg border border-brand-gold/8 bg-white/[0.015]" data-id="element-27">
            <span className="text-brand-gold font-body font-semibold text-sm md:text-base" data-id="element-28">
              {s.name}
            </span>
            <span className="text-brand-muted font-body text-sm" data-id="element-29">
              {s.application}
            </span>
          </div>)}
      </div>

      <p className="text-brand-ivory font-heading text-lg md:text-xl font-medium text-center mt-10 max-w-2xl mx-auto leading-relaxed" data-id="element-30">
        No inventamos nada nuevo. Integramos todo lo que ya funciona en un
        sistema de 24 horas. Eso es lo que faltaba.
      </p>
    </SectionWrapper>;
}